import React, { useEffect } from 'react';
import { Document, Page, View, Text,Image } from '@react-pdf/renderer';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../app/stores/store';
import { ConsolidatedReportStyles } from './ConsolidatedReportStyles';
import { getImageSrc } from '../../../../utils/ImageHelper';
import { getFirstSubtaskIdByName } from './service/types';
import agent from '../../../../app/api/agent';
import { balaSign } from './DCPEncryptedOpenReport';

const ConsolidatedRestorationReport = ({ subtaskId, isDualPDF }: { subtaskId: string, isDualPDF:boolean }) => {
  const { viewStore, activityStore, masteringStore } = useStore();
  useEffect(() => {
    const fetchData = async () => {
      try {
        // this api for NFAI-Restoration Consolidated Report
        let DeliverablesId = "";
        let NFHMColorGradingId = "";
        let RestorationId = "";
        const findDeliverablesId = getFirstSubtaskIdByName(viewStore.activeOrder || [],"Deliverables QC Report");
        DeliverablesId = findDeliverablesId || "";

        const findNFHMColorGradingId = getFirstSubtaskIdByName(viewStore.activeOrder || [],"NFHM Color Grading QC");
        NFHMColorGradingId = findNFHMColorGradingId || "";

        const findRestorationId = getFirstSubtaskIdByName(viewStore.activeOrder || [],"Restoration");
        RestorationId = findRestorationId || "";
          const { data }:any = await agent.NFAI.Consolidated(activityStore.selectedActivity?.id, subtaskId || "", DeliverablesId, NFHMColorGradingId, RestorationId);
          masteringStore.consolidatePDFinfo = data;
      } catch (err) {
        console.error('Error fetching report data:', err);
      }
    };
    fetchData();
    // eslint-disable-next-line
  }, [subtaskId, isDualPDF]);

  // Helper function to render checkbox
      const renderCheckbox = (isChecked: boolean) => (
      <View style={ConsolidatedReportStyles.checkbox}>
       {isChecked ? <Image src={'/assets/Consolidated/tick.png'} style={{ width: "7px", height: "7px" }}/>: null}
      </View>
    );

  // Helper function to safely get data
  const getData = (index: number) => masteringStore.consolidatePDFinfo[index]?.elementValue || '';

  const headerSection = () => (<>
    <Text style={ConsolidatedReportStyles.headerTitle}>
      Consolidated Restoration Report and Quality Sign Off
    </Text>

    <Text style={ConsolidatedReportStyles.vendorRow}>
      Vendor Name: Prasad Corporation Private Limited, Chennai
    </Text>

    <Text style={ConsolidatedReportStyles.subHeaderRow}>
      Title Details (Enter relevant details)
    </Text>
  </>);

  const firstTableList = () => (<>
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>Client</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <Text>{getData(46)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]}>
        <Text>Input Material</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]}>
        <Text>DPX</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]}>
        <Text>Start Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]}>
        <Text>{getData(13)}</Text>
      </View>
    </View>

    {/* Row 2 */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>Title</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <Text>{getData(0)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]}>
        <Text>Unique ID</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]}>
        <Text>{getData(1)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]}>
        <Text>End Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]}>
        <Text>{getData(14)}</Text>
      </View>
    </View>

    {/* Row 3 */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>Director</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <Text>{getData(5)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]}>
        <Text>Year</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]}>
        <Text>{getData(6)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]} />
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]} />
    </View>

    {/* Row 4 */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>Language</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <Text>{getData(2)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]}>
        <Text>Bit Depth</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]}>
        <View style={ConsolidatedReportStyles.checkboxRow}>
          <View style={ConsolidatedReportStyles.checkboxItem}>
            {renderCheckbox(getData(8).includes('10'))}
            <Text>10 bit</Text>
          </View>
          <View style={ConsolidatedReportStyles.checkboxItem}>
            {renderCheckbox(getData(8).includes('16'))}
            <Text>16 bit</Text>
          </View>
        </View>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]} />
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]} />
    </View>

    {/* Row 5 - Source DPX */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>Source DPX</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <View style={ConsolidatedReportStyles.checkboxRow}>
          <View style={ConsolidatedReportStyles.checkboxItem}>
            {renderCheckbox(getData(3).toLowerCase().includes('b & w'))}
            <Text>B&W</Text>
          </View>
          <View style={ConsolidatedReportStyles.checkboxItem}>
            {renderCheckbox(getData(3).toLowerCase().includes('colour'))}
            <Text>COLOR</Text>
          </View>
          <View style={ConsolidatedReportStyles.checkboxItem}>
            {renderCheckbox(getData(3).toLowerCase().includes('log'))}
            <Text>LOG</Text>
          </View>
          <View style={ConsolidatedReportStyles.checkboxItem}>
            {renderCheckbox(getData(3).toLowerCase().includes('linear'))}
            <Text>LINEAR</Text>
          </View>
        </View>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]}>
        <Text>Resolution</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]}>
        <Text>4609x3216</Text>
        <Text>({getData(7)})</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]}>
        <Text>Committed Del. Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]}>
        <Text></Text>
      </View>
    </View>

    {/* Row 6 */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>No. of Reels</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <Text>{getData(4)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]}>
        <Text>Level of Restoration</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]}>
        <Text>{getData(10)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]}>
        <Text>Actual Delivery Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]}>
        <Text>{getData(16)}</Text>
      </View>
    </View>

    {/* Row 7 */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol1]}>
        <Text>No. of Frames</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol2]}>
        <Text>{getData(17)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol3]} />
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol4]} />
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol5]} />
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.fcol6]} />
    </View>
  </>);

  const RestorationSection = () => (<>
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1, ConsolidatedReportStyles.grayCell]}>
        <Text>Restoration</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2 , {padding : '0px'}]}>
        <Text style={[{ borderBottom: '1px solid black' , padding: '2px', width : '100%'}]}>Start Date:</Text>
        <Text style={{padding: '2px'}}>{getData(19)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3 , {padding : '0px'}]}>
        <Text style={[{ borderBottom: '1px solid black' , padding: '2px' , width : '100%'}]}>End Date:</Text>
        <Text style={{padding: '2px'}}>{getData(20)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell , ConsolidatedReportStyles.col4]}>
        <Text>Comments</Text>
        <Text></Text>
      </View>
    </View>
  </>);

  const ProjectChecklistRow = () => (<>
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1, { borderRight: '1px solid black',borderBottomWidth:0 }]}>
        <Text>Project Checklist</Text>
        <Text>(Enter Yes or No)</Text>
      </View>
        <View style={[ConsolidatedReportStyles.col2, ConsolidatedReportStyles.tableRow, { borderRight: '0.7px solid black'}]}>
          <Text style={[{borderRight: '0.7px solid black' ,padding: '12px 0px' , width : '50%' , textAlign: 'center'}]}>Inventory Report</Text>
          <Text style={{padding: '12px 0px', width : '50%' , textAlign: 'center'}}>Attached</Text>
        </View>
        <View style={[ConsolidatedReportStyles.col3, ConsolidatedReportStyles.tableRow,{ borderRight: '0.7px solid black'}]}>
          <Text style={[{borderRight: '0.7px solid black' ,padding: '8px 0px', width : '50%' , textAlign: 'center'}]}>Internal QC Rejection Report</Text>
          <Text style={{padding: '12px 0px', width : '50%', textAlign: 'center' }}>Attached</Text>
        </View>
      <View style={[ConsolidatedReportStyles.col4]}>
        <View style={{ padding: "2px", flexDirection: 'row', justifyContent: 'center', alignContent: 'center' ,height: 50*4 , flex: 1}}>
          <Text style={{ paddingTop: "10px" }}>{getData(21)}</Text>
        </View>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={ConsolidatedReportStyles.col1}>
      </View>
        <View style={[ ConsolidatedReportStyles.col2, ConsolidatedReportStyles.tableRow, { borderRight: '0.7px solid black',borderTop: '1px solid black'}]}>
          <Text style={[{borderRight: '0.7px solid black' ,padding: '8px 0px', width : '50%' , textAlign: 'center'}]}>Analysis Report</Text>
          <Text style={{padding: '12px 0px', width : '50%' , textAlign: 'center'}}>Attached</Text>
        </View>
        <View style={[ ConsolidatedReportStyles.col3, ConsolidatedReportStyles.tableRow,{ borderRight: '0.7px solid black',borderTop: '1px solid black'}]}>
          <Text style={[{borderRight: '0.7px solid black' ,padding: '8px 0px', width : '50%' , textAlign: 'center'}]}>Restoration Report</Text>
          <Text style={{padding: '12px 0px', width : '50%' , textAlign: 'center'}}>Attached</Text>
        </View>
      <View style={[ConsolidatedReportStyles.col4,ConsolidatedReportStyles.tableRow]}>
        <Text style={{ padding: "2px" }}></Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.col1, { borderBottomWidth: '1px' }]}>
      </View>
        <View style={[ConsolidatedReportStyles.col2, ConsolidatedReportStyles.tableRow, { borderRight: '0.7px solid black',borderTop: '1px solid black'}]}>
          <Text style={[{borderRight: '0.7px solid black' ,padding: '9px 0px', width : '50%' , textAlign: 'center'}]}>Softwares Used</Text>
          <Text style={{padding: '12px 0px', width : '50%' , textAlign: 'center'}}>Diamant</Text>
        </View>
        <View style={[ConsolidatedReportStyles.col3, ConsolidatedReportStyles.tableRow,{ borderRight: '0.7px solid black',borderTop: '1px solid black'}]}>
          <Text style={{padding: '12px 0px', width : '50%' , textAlign: 'center',borderRight: '0.7px solid black'}}>NFAI QC Report</Text>
          <Text style={{padding: '12px 0px', width : '50%' , textAlign: 'center'}}>Attached</Text>
        </View>
      <View style={[ConsolidatedReportStyles.col4]}>
        <Text style={[ConsolidatedReportStyles.tableRow, { padding: "2px" }]}></Text>
      </View>
    </View>
  </>);

  const QcRejectedFrames = () => (<>
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text>QC Rejected Frames</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableRow, ConsolidatedReportStyles.col2 , {borderTop: '1px solid black' , borderBottom: '1px solid black '}]}>
        <Text style={{ width : '50%' , textAlign: 'center',borderRight: '1px solid black',padding: '12px 0px'}}>{getData(23)}</Text>
        <Text style={{ width : '50%' , textAlign: 'center',padding: '12px 0px'}}>FQA Rejected Frames</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3, {borderTop: '1px solid black'}]}>
             {getData(24) ? <Text style={{ textAlign: 'center'}}>{getData(24)}</Text> : null}
      </View>
      <View style={[ConsolidatedReportStyles.col4, { borderTopWidth: 0 }]}>
        <Text style={{ padding: "2px" }}></Text>
      </View>
    </View>

    {/* Quality Sign Off */}
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text></Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Quality Sign Off with Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(22)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.col4, { borderBottomWidth: 1 }]}>
        <Text style={{ padding: "2px" }}></Text>
      </View>
    </View>
  </>);

  const gradingRender = () => (<>
  
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1, ConsolidatedReportStyles.grayCell]}>
        <Text>Grading</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Start Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>End Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>Remarks</Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text></Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>{getData(25)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(26)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>{getData(27)}</Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text></Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Quality Sign Off with Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(28)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell,ConsolidatedReportStyles.col4]}>
        <Text></Text>
      </View>
    </View>

  </>);

  const subtitleRender = () => (<>
    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1, ConsolidatedReportStyles.grayCell]}>
        <Text>Subtitling</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Yes</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>No</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>Remarks</Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]} />
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>{getData(29) === 'Yes' ? <Image src={'/assets/Consolidated/tick.png'} style={{ width: '12px', height: '12px' }} /> : null}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(29) === 'No' ? <Image src={'/assets/Consolidated/close.png'} style={{ width: '10px', height: '10px' }} /> : null}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>{getData(30)}</Text>
      </View>
    </View>
  </>);

  const MasteringRender = () => (<>
  <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1, ConsolidatedReportStyles.grayCell]}>
        <Text>Mastering & DCP</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Start Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>End Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>Remarks</Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text></Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>{getData(31)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(32)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>{getData(33)}</Text>
      </View>
    </View>
  </>);

  const DeliverablesRender = () => (<>
  <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1, ConsolidatedReportStyles.grayCell]}>
        <Text>Deliverables</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Start Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>End Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>Remarks</Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text></Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>{getData(34)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(35)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, { width: '40%' }]}>
        <Text>{getData(36)}</Text>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.tableRow}>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col1]}>
        <Text></Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col2]}>
        <Text>Quality Sign Off with Date</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.col3]}>
        <Text>{getData(37)}</Text>
      </View>
      <View style={[ConsolidatedReportStyles.tableCell,ConsolidatedReportStyles.col4]}>
        <Text></Text>
      </View>
    </View>
  </>);


  const signRender = () => (<>
    <View style={ConsolidatedReportStyles.aboveSign}><Text></Text></View>
    <View style={ConsolidatedReportStyles.signatureSection}>
      <Text style={ConsolidatedReportStyles.signatureHeader}>Delivered by Vendor Name:</Text>

      <View style={ConsolidatedReportStyles.signatureRow}>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellLeft, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Date of Delivery</Text>
          <Text style={[ConsolidatedReportStyles.signatureLine]}>{getData(39)}</Text>
        </View>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellRight, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:5}]}>Vendor Project Manager Name & Signature</Text>
          <View style={{alignItems: 'center'}}>
          <Image
                src={getImageSrc('vijayalakshmi').toString() 
                }
                style={{ width: 120, height: 50 }}
              />
          </View>
          <Text style={ConsolidatedReportStyles.signatureLine}>{getData(38)}</Text>
        </View>
      </View>

      <View style={ConsolidatedReportStyles.signatureRow}>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellLeft, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Final Sign off Date</Text>
          <Text style={[ConsolidatedReportStyles.signatureLine, ConsolidatedReportStyles.signDatealign]}>{getData(41)}</Text>
        </View>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellRight, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Vendor QC Supervisor Name & Signature</Text>
          <View style={{alignItems: 'center'}}>
          <Image
                src={
                  getData(40).toLowerCase()?.includes('riaz khan') 
                  ? getImageSrc('riaz khan').toString() 
                  : getData(40).toLowerCase()?.includes('siddharth') 
                  ? getImageSrc('siddharth').toString() 
                  : getData(40).toLowerCase()?.includes('kalai') 
                  ? getImageSrc('kalai').toString() 
                  : getData(40).toLowerCase()?.replaceAll(' ','')?.includes('arulkumar')
                  ? getImageSrc('arulkumar').toString() 
                  : getData(40).toLowerCase()?.includes('karthick') 
                  ? getImageSrc('karthick').toString() 
                  : getData(40)?.toLowerCase()?.includes('pramod')
                  ? getImageSrc('pramod').toString() 
                  : getData(40).toLowerCase()?.includes('rajan') 
                  ? getImageSrc('rajan')
                  : getImageSrc('').toString() 
                }
                style={{ width: 120, height: 55 }}
              />
          </View>
          <Text style={ConsolidatedReportStyles.signatureLine}>
              {getData(40)}</Text>
        </View>
      </View>
    </View>

    <View style={ConsolidatedReportStyles.signatureSection}>
      <Text style={ConsolidatedReportStyles.signatureHeader}>Delivered to NFDC-NFAI:</Text>

      <View style={ConsolidatedReportStyles.signatureRow}>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellLeft,{borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Date of Delivery</Text>
          <Text style={[ConsolidatedReportStyles.signatureLine,ConsolidatedReportStyles.signDatealign]}>{getData(43)}</Text>
        </View>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellRight, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Project Manager Name & Signature</Text>
          <View style={{alignItems: 'center'}}>
           <Image
                src={
                  getData(42).toLowerCase()?.includes('riaz khan') 
                  ? getImageSrc('riaz khan').toString() 
                  : getData(42).toLowerCase()?.includes('siddharth') 
                  ? getImageSrc('siddharth').toString()
                  :getData(42).toLowerCase()?.includes('kalai') 
                  ? getImageSrc('kalai').toString()
                  :getData(42).toLowerCase()?.replaceAll(' ','')?.includes('arulkumar')
                  ? getImageSrc('arulkumar').toString()
                  : getData(42).toLowerCase()?.includes('karthick') 
                  ? getImageSrc('karthick').toString()
                  : getData(42).toLowerCase()?.includes('pramod')
                  ? getImageSrc('pramod').toString()
                  : getData(42).toLowerCase()?.includes('rajan') 
                  ? getImageSrc('rajan').toString()
                   : getImageSrc('').toString()
                }
                style={{ width: 120, height: 50 }}
              />
          </View>
          <Text style={ConsolidatedReportStyles.signatureLine}>
              {getData(42)}</Text>
        </View>
      </View>

      <View style={ConsolidatedReportStyles.signatureRow}>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellLeft, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Final Sign off Date</Text>
          <Text style={[ConsolidatedReportStyles.signatureLine,ConsolidatedReportStyles.signDatealign]}>{getData(45)}</Text>
        </View>
        <View style={[ConsolidatedReportStyles.signatureCell, ConsolidatedReportStyles.signatureCellRight, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>NFHM QC Supervisor Name & Signature</Text>
           <View style={{alignItems: 'center'}}>
           <Image
                src={
                  getData(44).toLowerCase()?.includes('pramod')
                  ? getImageSrc('pramod').toString()
                  : getData(44).toLowerCase()?.includes('rajan') 
                  ? getImageSrc('rajan').toString()
                  : getImageSrc('').toString()
                } 
                style={{ width: 120, height: 50 }}
              />
            </View>
          <Text style={ConsolidatedReportStyles.signatureLine}>
            {getData(44)}</Text>
        </View>
      </View>

      <View style={ConsolidatedReportStyles.signatureRow}>
        <View style={[ConsolidatedReportStyles.signatureCell1, ConsolidatedReportStyles.signatureCellLeft, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>Final Sign off Date</Text>
          <Text style={[ConsolidatedReportStyles.signatureLine,ConsolidatedReportStyles.signDatealign]}></Text>
        </View>
        <View style={[ConsolidatedReportStyles.signatureCell1, ConsolidatedReportStyles.signatureCellRight, {borderBottomWidth:1}]}>
          <Text style={[ConsolidatedReportStyles.signatureText, {borderBottomWidth:1, padding:4}]}>NFHM Deliverables QC Supervisor Name & Signature</Text>
          <Text style={ConsolidatedReportStyles.signatureLine}></Text>
        </View>
      </View>
    </View>
  </>);
  return (
    <Document>
      <Page size="A4" style={ConsolidatedReportStyles.page}>
        {/* Header */}
        <View style={ConsolidatedReportStyles.tableContainer}>
          {headerSection()}
          {firstTableList()}
          <View style={ConsolidatedReportStyles.tableRow}>
            <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.narrowCol, { borderRightWidth: '1px' }]}>
              <Text>Remarks on Completeness of the film</Text>
            </View>
            <View style={[ConsolidatedReportStyles.tableCell, ConsolidatedReportStyles.wideCol]}>
              <Text>{getData(18)}</Text>
            </View>
          </View>

          {/* Restoration section */}
          {RestorationSection()}

          {/* Project Checklist rows */}
          {ProjectChecklistRow()}

          {/* QC Rejected Frames */}
          {QcRejectedFrames()}

          {/* Grading */}
          {gradingRender()}

          {/* Subtitling */}
          {subtitleRender()}
     {isDualPDF ? <View style={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'flex-end', marginRight: "150px",padding: 5, marginTop: "7px", marginBottom: "18px" }}>
                    <Image 
                      src={getImageSrc('bala')} 
                      style={{ width: 60, height: 40 }} 
                    />
                  </View> : null}
          {/* Mastering & DCP */}
          {MasteringRender()}

     
          {/* Deliverables */}
          {DeliverablesRender()}

          {/* Signature Sections */}
          {signRender()}
        </View>
       {isDualPDF ? balaSign('10',false) : null}
      </Page>
    </Document>
  );
};

export default observer(ConsolidatedRestorationReport);